<template>
  <div />
</template>

<script>
export default {
  name:"CallTakerStore",
  data () { return {
    interval: undefined,
    callTakers: undefined,
    url: '',
    metaCallTakers: {},
    baseURL: 'https://fandango-wombat-7897.twil.io',

  }},
  mounted: async function(){
    this.url = `${this.baseURL}/ws2_call_takers?k=${this.$_auid}`
    this.loadData();
    this.interval = setInterval(this.loadData, 10000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    loadData: async function(){
      if(!document.hasFocus())
        return;
      const r = await axios.get(`${this.url}&m=list`)
      r.data.forEach(row=> row.attributes = JSON.parse(row.attributes))
      // r.data.forEach(row=> this.metaCallTakers[row.sid] = !this.metaCallTakers[row.sid] ? {} : this.metaCallTakers[row.sid] )
      // r.data.forEach(row=> !this.metaCallTakers[row.sid] ? this.metaCallTakers[row.sid] = {} : 1+1 )
      r.data.forEach(row=> !this.metaCallTakers[row.sid] ? this.$set(this.metaCallTakers, row.sid, {}) : 1+1 )
      this.callTakers = r.data;
    },
    preformCleanAll: async function(){
      await this.$axios.get(`${this.baseURL}/ws2_cleanAll?k=${this.$_auid}`);
      this.loadData();
    },
    callTakerReverseState: function(callTaker){
      return callTaker.activityName === "Offline" ? "Available" : "Offline" 
    },
    preformCallTakerReverseState: async function(callTaker){
      const r = await axios.get(`${this.url}&m=reverseState&wsid=${callTaker.sid}&toState=${this.callTakerReverseState(callTaker)}`)
      this.loadData();
      this.$set(this.metaCallTakers[callTaker.sid], 'showStateOptions', false);
    },
    preformCallTakerContactSwitch: async function(callTaker){
      this.$set(this.metaCallTakers[callTaker.sid], 'showContactOptions', false);
      if (!callTaker.attributes.alt_contact_uri)
        return;
      const r = await axios.get(`${this.url}&m=switchContact&wsid=${callTaker.sid}`)
      this.loadData();
    },
  },

  computed: {
    sortedCallTakers: function(){
      if(!this.callTakers) 
        return [];
      const nonOffCTs = this.callTakers.filter(r=>r.activityName!=='Offline')
      const offCTs = this.callTakers.filter(r=>r.activityName==='Offline')
      return [...this.$util.sortAscForKeyPath(nonOffCTs, `activityName`), ...offCTs]
    }
  }
}
</script>